'use client'; // Error components must be Client Components

import {
  getClientApplicationConfig,
  getClientApplicationContext,
} from '@hc-frontend/core-context';
import { Button } from '@hc-frontend/core-ui';
import { useEffect } from 'react';

export function LogError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const config = getClientApplicationConfig();

  useEffect(() => {
    const context = getClientApplicationContext(LogError);
    // Log the error to an error reporting service
    context.log({
      type: 'error',
      data: {
        rootCause: error,
      },
      context: 'client',
      message:
        error.message + (error.digest ? ` - digest: ${error.digest}` : ''),
    });
  }, [error]);

  return (
    <div className="hc-container-layout hc-stack-layout justify-center text-center">
      <h1 className="hc-typography--title-case">
        {config.errors.core.unexpectedException}
      </h1>
      <Button
        type="button"
        variant="secondary-dark"
        className="w-auto"
        onClick={
          // Attempt to recover by trying to re-render the segment
          () => reset()
        }
      >
        {config.errors.core.tryAgain}
      </Button>
    </div>
  );
}
